module.exports = __webpack_public_path__ + "img/my-assets.a7abc8d5.png";